// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextAreaField_textArea__2n9CN","textAreaReadOnly":"TextAreaField_textAreaReadOnly__2xNPW"};